if (!customElements.get('framed-shipping-note')) {
  customElements.define(
    'framed-shipping-note',
    class FramedShippingNote extends HTMLElement {
      constructor() {
        super();
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.openDetails = this.openDetails.bind(this);
      }

      connectedCallback() {
        this.detailsTrigger = this.querySelector('[data-framed-details-trigger]');
        this.detailsTrigger?.addEventListener('click', this.openDetails);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
      }

      disconnectedCallback() {
        this.detailsTrigger?.removeEventListener('click', this.openDetails);
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChange({ data: { sectionId, variant } }) {
        if (sectionId !== this.dataset.sectionId || !variant) return;

        const variantText = [variant.title, ...(variant.options || [])].filter(Boolean).join(' ').toLowerCase();
        this.hidden = variantText.includes('unframed');
      }

      openDetails() {
        const details = document.getElementById(this.dataset.detailsId);
        if (!details) return;

        details.open = true;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        details.scrollIntoView({ behavior, block: 'center' });
        window.requestAnimationFrame(() => details.querySelector('summary')?.focus({ preventScroll: true }));
      }
    }
  );
}
